import { ActivityFormConfig } from './form.common';

const activityFormsPreviewInfoSets: Array<ActivityFormConfig> = [
    {
        views: {
            classic: 'survey-editor-standalone',
            mobile: 'survey-editor-mobile'
        },

        isActive: ({ topic, user }) => topic.isSurvey() && user.isModerator()
    },

    {
        views: {
            'classic': 'video-presentation-editor-standalone',
            'mobile': 'video-presentation-editor-mobile'
        },

        isActive: ({ topic, user }) => topic.isVideoPresentation() && user.isModerator()
    },

    {
        views: {
            classic: 'externalsurvey-editor-mod'
        },

        isActive: ({ topic, user }) => topic.isExternalSurvey() && user.isModeratorOrObserver()
    },
]

export default activityFormsPreviewInfoSets;